export enum DncType {
  GLOBAL = 'global',
  USER = 'user',
  ALL = 'all',
}

export type DncNumber = {
  id: string;
  phoneNumber: string;
  type: DncType;
  userId?: string;
  createdAt: string;
  updatedAt: string;
  reason?: string;
};

export type AddDncNumberDto = {
  phoneNumber: string;
  userId?: string;
  reason?: string;
};

export type BulkAddDncNumberDto = {
  phoneNumbers: string[];
  userId?: string;
  reason?: string;
};

export type RemoveDncNumberDto = {
  phoneNumber: string;
  userId?: string;
};

export type PaginatedDncNumberDto = {
  items: DncNumber[];
  total: number;
  page: number;
  size: number;
  totalPages: number;
};
